import PropTypes from 'prop-types'
import React, { Component } from 'react'
import SelectField from '../SelectField'
import countries from './countries'
import { injectIntl } from 'react-intl'
export class CountrySelector extends Component {

  static propTypes = {
    placeholder: PropTypes.string,
    intl: PropTypes.object,
  }

  getCountryOptions (intl) {
    return Object.keys(countries).map(countryCode => {
      const message = countries[countryCode]
      return {
        label: intl.formatMessage(message),
        value: countryCode.toUpperCase(),
      }
    }).sort((a, b) => a.label.localeCompare(b.label))
  }

  render () {
    const { placeholder = 'Country', intl } = this.props
    return (
      <SelectField
        {...this.props}
        placeholder={placeholder}
        options={this.getCountryOptions(intl)}
      />
    )
  }
}

export default injectIntl(CountrySelector)



// WEBPACK FOOTER //
// ./src/components/forms/CountrySelector/CountrySelector.jsx